import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Public from './components/Public/Public';
import Login from './components/Auth/Login';
import SetPassword from './components/Auth/SetPassword';
import { useAuth } from './context/AuthContext';
import AdminApp from './dashboard/admin/AdminApp';
import AdminOverview from './dashboard/admin/Overview';
import AdminResellers from './dashboard/admin/Resellers';
import AdminProducts from './dashboard/admin/Products';
import { Activity, Commissions, Customers, Payouts } from './dashboard/admin/ListPages';
import PartnerApp from './dashboard/partner/PartnerApp';
import PartnerOverview from './dashboard/partner/Overview';
import { Customers as PartnerCustomers, Earnings, Settings, Share, Support } from './dashboard/partner/Pages';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { token, role } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public site: top bar layout, unchanged. */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Public />} />
          <Route path="login" element={<Login />} />
          <Route path="set-password" element={<SetPassword />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>

        {/* Dashboards: sidebar layout. Admin sees everything; a partner only sees their own data. */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminApp />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminOverview />} />
          <Route path="resellers" element={<AdminResellers />} />
          <Route path="commissions" element={<Commissions />} />
          <Route path="payouts" element={<Payouts />} />
          <Route path="customers" element={<Customers />} />
          <Route path="activity" element={<Activity />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>

        <Route
          path="/owner/:id"
          element={
            <ProtectedRoute allowedRoles={['reseller', 'owner']}>
              <PartnerApp />
            </ProtectedRoute>
          }
        >
          <Route index element={<PartnerOverview />} />
          <Route path="customers" element={<PartnerCustomers />} />
          <Route path="earnings" element={<Earnings />} />
          <Route path="share" element={<Share />} />
          <Route path="settings" element={<Settings />} />
          <Route path="support" element={<Support />} />
          <Route path="*" element={<Navigate to=".." replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
